export default __webpack_public_path__ + "static/media/videoPoster.beb14a11.png";